import { defineEndpoints } from '@blockworks/platform/api';

type PostSlackWebhookBody = {
    code: string;
    redirectUri: string;
};

const SHARE_FEEDBACK_OPTIONS = [
    { label: 'Bug/Error', value: 'bug_or_error' },
    { label: 'Data Issue', value: 'data_issue' },
    { label: 'Feature Request', value: 'feature_request' },
    { label: 'Usability Issue', value: 'usability_issue' },
    { label: 'Other', value: 'other' },
];

const SHARE_FEEDBACK_LABEL_BY_VALUE = SHARE_FEEDBACK_OPTIONS.reduce(
    (acc, option) => {
        acc[option.value as any] = option.label;
        return acc;
    },
    {} as Record<string, string>,
);

type PostShareFeedbackRequest = {
    category: string;
    description: string;
    userEmail: string;
    route: string;
};

type PostShareFeedbackResponse = {
    error?: string;
    description?: string;
    success: boolean;
};

const INTERNAL_SLACK_ENDPOINTS = defineEndpoints(template => ({
    POST: {
        SLACK_WEBHOOKS: template('/api/slack/webhooks'),
        SHARE_FEEDBACK: template('/api/slack/feedback'),
    },
}));

export type { PostShareFeedbackRequest, PostShareFeedbackResponse, PostSlackWebhookBody };

export { INTERNAL_SLACK_ENDPOINTS, SHARE_FEEDBACK_LABEL_BY_VALUE, SHARE_FEEDBACK_OPTIONS };
